import React from 'react'
import styled from '@emotion/styled'

import { Stack, Typography } from '@mui/material'

import { SharePdfAction } from '../SharePdfAction'
import { ToolbarWithButtons, useIsMobile } from '@edge/spark/ui-mui'
import { SendAmsAction } from '../SharePdfAction/SendAmsAction'
import { ReportActionButton } from '../ReportActionButton'
import { useCheckReportRolesOrAdmin } from '@edge/spark/io-roles'
import { useTableContext } from '@edge/spark/io-react-table'
import { SelectWorkflowButtons } from '../../feature-action-drawer'

const SelectedCount = styled(Typography)`
    flex: 1;
    align-self: center;
    @media screen and (max-width: 600px) {
        font-size: 14px;
    }
    @media screen and (orientation: landscape) and (max-width: 800px) {
        font-size: 14px;
    }
`

interface Props {
    count?: number
    loading?: boolean
    loadingAMS?: boolean
    loadingShare?: boolean
    onClickAMS?: () => void
    onClickShare?: () => void
    subtitle?: string
    title: string
    disabled?: any
    isOverviewDetails?: boolean
}
const REPORT_HREF = '/auction/reportsv2?report=Sales By Week Chart'
const MAX_COUNT = 5

export const ToolbarWithActions: React.FC<Props> = ({
    loading,
    loadingAMS,
    loadingShare,
    disabled,
    onClickAMS,
    onClickShare,
    subtitle,
    title,
    isOverviewDetails,
}: Props) => {
    const count = useTableContext((s) => s.getSelectedRowCount())
    const mobile = useIsMobile()
    const showReportButton = useCheckReportRolesOrAdmin() && isOverviewDetails && !mobile

    return (
        <ToolbarWithButtons subtitle={subtitle} title={title}>
            <Stack direction="row" gap={1}>
                {!!count && (
                    <SelectedCount variant="h5">
                        Selected {count} {count >= MAX_COUNT && onClickAMS && `(${MAX_COUNT} Max)`}
                    </SelectedCount>
                )}
                {!!count && <SelectWorkflowButtons />}
                {showReportButton && <ReportActionButton href={REPORT_HREF} />}
                {onClickAMS && (
                    <SendAmsAction
                        disabled={disabled || !onClickAMS || !count || count > MAX_COUNT}
                        loading={loading || loadingAMS}
                        onShare={onClickAMS}
                    />
                )}
                {onClickShare && (
                    <SharePdfAction disabled={disabled} loading={loading || loadingShare} onShare={onClickShare} />
                )}
            </Stack>
        </ToolbarWithButtons>
    )
}

export default ToolbarWithActions
export type { Props as ToolbarWithActionsProps }
